import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { TooltipComponent } from '../../../modules/mapfre-design-library/src/lib/_components/section-components/tooltip/tooltip.component';
import { MapfreButtonComponent } from '../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, TooltipComponent, MapfreButtonComponent],
  selector: 'app-add-missing-policy',
  templateUrl: './add-missing-policy.component.html',
  styleUrls: ['./add-missing-policy.component.scss']
})
export class AddMissingPolicyComponent implements OnInit {
  isAcmic: boolean;
  placeHolderText: string;
  missingPolicyForm: FormGroup;

  constructor(private acmicService: AcmicService, private router: Router,) {
    this.isAcmic = this.acmicService.isACMIC();
    this.placeHolderText = 'Type policy number here';
  }

  ngOnInit(): void {
    this.setDefaultForm();
  }

  setDefaultForm() {
    this.missingPolicyForm = new FormGroup({
      missingPolicyNumber: new FormControl(null)
    });
  }

  addPolicy() {
    this.router.navigate(['/my-insurance', 'link-policy'], {
      state: { missingPolicyNumber: this.missingPolicyForm.controls.missingPolicyNumber.value },
    });
  }
}
